<template>
  <div class="slide_inner">
    <div class="absolute left-0 slide__img-wrap">
      <template v-for="(image, i) in slideData.images">
        <img
          class="relative slide__img shadow-xl"
          v-bind:class="'slide__img--' + (i + 1)"
          v-bind:src="image.src"
          v-bind:alt="image.title"
          :style="imgStyle(i)"
        />
        <div class="break" v-if="i === 1" />
      </template>
    </div>
    <h2 class="text-white slide__title font-display" :style="headerStyle">
      <span class="slide__title-inner">{{ slideData.title[0] }} </span>
      <!-- <span class="slide__title-inner">{{ slideData.title[1] }}</span> -->
    </h2>
  </div>
</template>
<script>
export default {
  props: {
    slide: {
      type: Object,
      required: true,
    },
  },

  computed: {
    slideData() {
      return this.slide.data
    },

    headerStyle() {
      return {
        opacity: this.slide.headerOpacity,
      }
    },
  },

  methods: {
    imgStyle(i) {
      let xKey = 'x' + i
      let yKey = 'y' + i

      return {
        opacity: this.slide.opacity,
        left: this.slide[xKey] + '%',
        top: this.slide[yKey] + '%',
      }
    },
  },
}
</script>
